import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { appToast } from '@/core/error/toast';
import { resolvePageVisitMessage } from '@/core/layout/pageTitleUtils';

const AUTH_PREFIXES = ['/login', '/forgot-password', '/reset-password'];

function isAuthRoute(pathname: string): boolean {
  return AUTH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

/**
 * Credora-style page visit toast — brief info notification when navigating inside the app shell.
 */
export function PageVisitToast() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (isAuthRoute(location.pathname)) {
      return;
    }
    if (lastPath.current === location.pathname) {
      return;
    }
    lastPath.current = location.pathname;

    const title = resolvePageVisitMessage(location.pathname);
    if (title) {
      appToast.pageLoaded(title);
    }
  }, [location.pathname]);

  return null;
}
